import { ProductReview } from "@interfaces/dto/products.dto";
import { decode } from "html-entities";

interface Props {
  reviews: ProductReview[];
  productDescHtml: string | undefined;
}

const productSpecific = ({ reviews, productDescHtml }: Props) => {
  return (
    <>
      <div className="bg-white p-3 rounded-2">
        <div className="description">
          <h5 className="title">รายละเอียด</h5>
          <div
            dangerouslySetInnerHTML={{ __html: decode(productDescHtml) }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default productSpecific;
